<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :fill="fill" d="M8.04351 8.88138H0.837861C0.383019 8.88138 -5.8445e-06 8.49836 -5.8445e-06 8.04351C-5.8445e-06 3.59085 3.61479 -5.8445e-06 8.04351 -5.8445e-06C8.49836 -5.8445e-06 8.88138 0.383019 8.88138 0.837861V8.04351C8.88138 8.49836 8.49836 8.88138 8.04351 8.88138ZM1.72362 7.18171H7.20565V1.69966C4.3569 2.08269 2.08271 4.3569 1.72362 7.18171ZM11.7301 22C6.05658 22 1.46027 17.5952 1.46027 12.1611C1.46027 11.6344 1.89117 11.2035 2.41783 11.2035H11.2035V2.41783C11.2035 1.89117 11.6344 1.46027 12.1611 1.46027C17.4995 1.46027 22 6.17627 22 11.7301C22 17.3798 17.3798 22 11.7301 22ZM3.44723 13.1186C3.94995 17.0207 7.46898 20.0849 11.7301 20.0849C16.3264 20.0849 20.0849 16.3504 20.0849 11.7301C20.0849 7.5408 16.9967 3.97388 13.1186 3.44723V12.1611C13.1186 12.6877 12.6877 13.1186 12.1611 13.1186H3.44723Z" />
  </svg>

</template>

<script>
  export default {
    name: 'dashboardsIcon',
    props: {
      fill: {
        type: String,
        default: '#29ABE2'
      }
    }
  }
</script>
